import styles from './index.module.scss';
import React, { useState, useEffect } from 'react';
import FileTree from '../FileTree/FileTree';
import FilePondWrapper from '../FilePondWrapper';
import { useParams } from 'react-router-dom';

const FileSystemPanel: React.FC = () => {
  const [currentFolder, setCurrentFolder] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();
  useEffect(() => setCurrentFolder(id ? id : null), [id]);
  return (
    <div className={styles.FileSystemPanel}>
      <FilePondWrapper activeFolder={currentFolder} />
      <FileTree activeFolder={currentFolder} />
    </div>
  );
};

export default FileSystemPanel;
